const CHANGE_FLAG = 'flags/CHANGE_FLAG'

export default {
  CHANGE_FLAG
}
